import React, { useState, memo } from "react";
import Container from "../containers/Container";
import {
  FaApple,
  FaGooglePlay,
  FaInstagram,
  FaTelegramPlane,
  FaYoutube,
  FaPhoneAlt,
} from "react-icons/fa";
import SocialCard from "../ui/SocialCard";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";
import QrModal from "../ui/QrModal";
import Modal from "../ui/Modal";
import android from "../../assets/qr/qr_code_cyber_android.png";

const Footer: React.FC = () => {
  const lang = useLanguage();
  const { t } = useTranslation();
  const [openContactModal, setOpenContactModal] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [selectedStore, setSelectedStore] = useState<"android" | "ios">(
    "android"
  );

  const socials = [
    // { icon: <FaFacebookF />, url: "https://www.facebook.com/amaaruz/" },
    { icon: <FaTelegramPlane />, url: "https://t.me/amaar_uz" },
    { icon: <FaInstagram />, url: "https://www.instagram.com/amaar_uz/" },
    { icon: <FaYoutube />, url: "https://www.youtube.com/@amaar.uz1" },
    // { icon: <FaTwitter />, url: "https://twitter.com/amaaruz" },
    // { icon: <FaLinkedinIn />, url: "https://www.linkedin.com/in/amaaruz/" },
  ];

  // sadsdv 

  const socialsMedia = [
    {
      icon: <FaGooglePlay />,
      type: "android" as const,
      url: "https://play.google.com/store/apps/details?id=com.ats.amaar1",
    },
    {
      icon: <FaApple />,
      type: "ios" as const,
      url: "https://apps.apple.com/ae/app/amaar-plus/id6736830527",
    },
  ];

  const currentYear = new Date().getFullYear();

  return (
    <>
      <footer className="text-white mb-10 md:mb-0 pt-[18px] pb-[42px] bg-brand-gradient transition">
        <Container>
          <div className="flex justify-between items-start flex-wrap">
            {/* Contact Info */}
            <div>
              <p className="mb-[13px] text-[13px]">{t("contact")}</p>
              <div className="flex flex-col">
                <Link
                  to="tel:+998752200027"
                  className="text-[24px] font-medium hover:text-blue-200 transition-colors"
                  aria-label="test"
                >
                  <span>+998 75 220 00 27</span>
                </Link>
                <Link
                  to="tel:+998946282332"
                  className="text-[24px] font-medium hover:text-blue-200 transition-colors"
                  aria-label="test"
                >
                  <span>+998 94 628 23 32</span>
                </Link>
              </div>
              <div className="flex gap-3 my-[41px]">
                {socials.map((item, index) => (
                  <SocialCard
                    key={index}
                    icon={item.icon}
                    url={item.url}
                    label="test"
                  />
                ))}
              </div>
              {/* <p className="my-2 text-sm">{t("storeAddresses")}</p> */}
            </div>

            {/* Company */}
            <div className="mb-4 md:mb-0">
              <p className="font-medium text-[18px] mb-[24px]">
                {t("company")}
              </p>
              <ul className="font-normal space-y-3 text-sm text-white/80">
                <li>
                  <Link to={`/${lang}/about`} className="hover:text-white hover:underline transition-colors">
                    {t("aboutCompany")}
                  </Link>
                </li>
                <li>
                  <Link
                    to={`https://seller.amaar.uz/`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-white hover:underline transition-colors"
                  >
                    {" "}
                    {t("footer.seller", "Seller")}
                  </Link>
                </li>
              </ul>
            </div>

            {/* Information */}
            <div className="mb-4 md:mb-0">
              <p className="font-medium text-[18px] mb-[24px]">
                {t("information")}
              </p>
              <ul className="font-normal space-y-3 text-sm text-white/80">
                <li>
                  <Link to={`/${lang}/questions`} className="hover:text-white hover:underline transition-colors">
                    {t("freeDelivery")}
                  </Link>
                </li>
                <li
                  onClick={() => setOpenContactModal(true)}
                  className="cursor-pointer hover:text-white hover:underline transition-colors"
                >
                  {t("contactNumbers")}
                </li>
              </ul>
            </div>

            {/* Help */}
            <div className="mb-4 md:mb-0">
              <p className="font-medium text-[18px] mb-[24px]">
                {t("customerHelp")}
              </p>
              <ul className="font-normal space-y-3 text-sm text-white/80">
                <li>
                  <Link to={`/${lang}/questions`} className="hover:text-white hover:underline transition-colors">
                    {t("returnPolicy")}
                  </Link>
                </li>
                <li>
                  <Link to={`/${lang}/questions`} className="hover:text-white hover:underline transition-colors">
                    {t("warranty")}
                  </Link>
                </li>
              </ul>
            </div>

            {/* App Download */}
            <div>
              <p className="font-medium text-[18px] mb-[24px]">
                {t("downloadApp")}
              </p>
              <div className="flex gap-6">
                <img
                  loading="eager"
                  onClick={() => {
                    setSelectedStore("android");
                    setOpenModal(true);
                  }}
                  className="w-[142px] h-[142px] cursor-pointer rounded-xl bg-white p-1.5 hover:scale-105 transition-transform"
                  src={android}
                  alt={t("qrCodeAlt", "QR Code for app download")}
                />
                <div>
                  <div className="flex gap-3">
                    {socialsMedia.map((item, index) => (
                      // <a
                      //   key={index}
                      //   href={item.url}
                      //   target="_blank"
                      //   rel="noopener noreferrer"
                      //   className="p-2 bg-gray-800 rounded-md hover:bg-gray-700 text-white"
                      //   aria-label={t(
                      //     item.type === "android" ? "googlePlay" : "appStore",
                      //     item.type === "android" ? "Google Play" : "App Store"
                      //   )}
                      // >
                      //   {item.icon}
                      // </a>
                      <SocialCard
                        key={index}
                        icon={item.icon}
                        url={item.url}
                        label="test"
                      />
                    ))}
                  </div>
                  <p className="mt-2 text-[13px] max-w-[125px]">
                    {t("qrScanInstruction")}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <hr className="my-4 border-white/15" />
          <div className="flex justify-between items-center gap-3 text-[12px] flex-wrap text-white/70">
            <div className="flex gap-3">
              <Link to={`/${lang}/agreement`} className="hover:text-white hover:underline transition-colors">
                {t("privacyPolicy")}
              </Link>
              <Link to={`/${lang}/agreement`} className="hover:text-white hover:underline transition-colors">
                {t("userAgreement")}
              </Link>
            </div>
            <div>
              <p>{`“${currentYear} ${t("copyright")}"`}</p>
            </div>
          </div>
        </Container>
      </footer>

      {/* QR Modal */}
      <QrModal
        isOpen={openModal}
        onClose={() => setOpenModal(false)}
        initialStore={selectedStore}
      />
      {/* Kontack modal  */}
      <Modal
        isOpen={openContactModal}
        onClose={() => setOpenContactModal(false)}
        className="w-[400px]"
      >
        <div>
          <h2 className="text-2xl font-semibold mb-4">{t("support.title")}</h2>
          <p className="text-gray-700 mb-4">
            {t("support.description")}
          </p>

          <a
            href="https://t.me/Amaar_Support_Bot"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 py-2 px-2 -mx-2 rounded-xl hover:bg-gray-50 transition-colors"
          >
            <FaTelegramPlane className="text-[#2AABEE] text-3xl" />
            <div>
              <p className="font-semibold">{t("support.telegram.title")}</p>
              <p className="text-sm text-gray-600">{t("support.telegram.username")}</p>
            </div>
          </a>

          <a
            href="tel:+998752200027"
            className="flex items-center gap-3 py-2 px-2 -mx-2 rounded-xl hover:bg-gray-50 transition-colors"
          >
            <FaPhoneAlt className="text-green-500 text-2xl" />
            <div>
              <p className="font-semibold">+998 (75) 220-00-27</p>
              <p className="text-sm text-gray-600">{t("support.phone.label")}</p>
            </div>
          </a>

          <p className="text-sm text-gray-600 mt-3">
            {t("support.email.label")}:{" "}
            <a href="mailto:sales@ats-systems.net" className="text-blue-500">
              sales@ats-systems.net
            </a>
          </p>
        </div>
      </Modal>
    </>
  );
};

export default memo(Footer);
